var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mu-card-header',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"title":_vm.userinfo.username,"sub-title":_vm.userinfo.mobile}},[_c('mu-avatar',{attrs:{"slot":"avatar"},slot:"avatar"},[_c('img',{attrs:{"src":_vm.userinfo.userhead || _vm.defaultHead}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }